import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'

import ListView from '_components/list-view/index.jsx'
import Header from '_components/header/index.jsx'
import ContentRuleChangeRequestStatusBadge from '_components/content-rule-change-request-status-badge'

import { getEnumCreatedBy } from '_services/destinations'

import './styles.scss'

const DestinationChangeRequests = () => {
  const [createdByOptions, setCreatedByOptions] = useState([])

  useEffect(() => {
    getEnumCreatedBy().then(setCreatedByOptions)
  }, [])

  return (
    <div id="destination-change-request-page" className="destination-change-requests">
      <Header title="Destinations Change Requests" />
      <div className="batch-sidebar__list-view-wrapper">
        <ListView
          columns={[
            {
              name: 'Destination',
              link: '/destination-change-requests/:_id',
              key: 'destination.name',
              styles: {
                maxWidth: '400px',
                textAlign: 'left',
              },
              sortable: true,
            },
            {
              name: 'Status',
              key: 'status',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
              // eslint-disable-next-line react/display-name
              render: (item) => <ContentRuleChangeRequestStatusBadge status={item.status} />,
              sortable: true,
            },
            {
              name: 'Updated At',
              key: 'updated_at',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
              // eslint-disable-next-line react/display-name
              render: (item) => <span>{dayjs(item.created_at).format('MM/DD/YYYY HH:mm')}</span>,
              sortable: true,
            },
            {
              name: 'Created By',
              key: 'created_by.email',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
            },
          ]}
          entities="destination-change-requests"
          searchable={false}
          showCheckboxes={false}
          filters={[
            {
              name: 'status',
              label: 'Status',
              options: ['pending', 'approved', 'rejected', 'applied'],
              all: true,
            },
            {
              name: 'created_by.email',
              label: 'Created by',
              options: createdByOptions,
              all: true,
              className: 'audiences__filters',
            },
          ]}
          sort_key={'updated_at'}
          sort_dir={-1}
          dontStoreFilters
        />
      </div>
    </div>
  )
}

// export
export default DestinationChangeRequests
